import * as types from './types';
import update from 'immutability-helper';

const initialLoginForm = {
    userId: '',
    userPin: '',
    errorMessage: '',
    loading: false,
}

const defaultState = {
    credentials: {
    },
    isAuthenticated: false,
    isPublicAuthenticated: false,
    loginForm: {
        ...initialLoginForm
    },
    getmoduleAccessList: '',
    getaccessList: '',
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case types.SET_USER_AUTH:
            return {
                ...state,
                credentials: action.payload,
                isAuthenticated: action.isAuthenticated,
                getmoduleAccessList: action.getmoduleAccessList,
                getaccessList: action.getaccessList,
            };
        case types.CHG_FIELD:
            return update(state, {
                loginForm: {
                    [action.payload.name]: { $set: action.payload.value }
                }
            })
        case types.REFRESH_FORM:
            return update(state, {
                loginForm: { $set: initialLoginForm }
            });
        case types.SET_LOADER:
            return update(state, {
                loginForm: {
                    loading: { $set: action.payload }
                }
            })
        case types.SET_AUTHENTICATED:
            return {
                ...state,
                isAuthenticated: action.payload
            }
        case types.UPDATE_CREDENTIALS:
            return update(state, {
                credentials: {
                    [action.payload.name]: { $set: action.payload.value }
                }
            })
        case types.SET_PUBLIC_AUTHENTICATED:
            return {
                ...state,
                isPublicAuthenticated: action.payload
            }
        default: return state;
    }
};
